import { isEmpty } from "lodash";
import { io } from "socket.io-client";

import { hostname } from "./../../../services/configServices/config";

export const setSocketActions = (accessToken) => {
  return async (dispatch) => {
    const socket = io(hostname, {
      transports: ["websocket"],
    });
    socket.connect();
    socket.emit("connect-user", accessToken);

    await dispatch({ type: "SET_SOCKET", payload: socket });
  };
};

export const clearSocketActions = () => {
  return async (dispatch, getStates) => {
    const states = getStates();
    const socket = states?.socket;

    if (!isEmpty(socket)) {
      socket?.emit("close-user", states?.auth?.accessToken);
      socket?.close();
    }

    await dispatch({ type: "CLEAR_SOCKET", payload: {} });
  };
};
